import { getRouteScrollKey } from '~/utils/scrollRestoration';

const READY_STATE_KEY = 'scroll-ready';

export const useScrollRestoration = () => {
  const route = useRoute();
  const readyState = useState<Record<string, boolean>>(READY_STATE_KEY, () => ({}));

  const setReady = (value: boolean) => {
    if (!process.client) return;
    readyState.value[getRouteScrollKey(route)] = value;
  };

  const markReady = () => setReady(true);
  const resetReady = () => setReady(false);

  return {
    markReady,
    resetReady,
  };
};
